(function () {
  'use strict';

  var TZ = 'America/Denver';

  /* ── Cutoff hours (24h, America/Denver) ── */
  var CUTOFF_SAME_DAY = 11; /* midnight–11am  → ships today   */

  var ICON_CLOCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>' +
    '</svg>';

  var STATE_CLASSES = [
    'jug-pdp-urgency--countdown',
    'jug-pdp-urgency--state1',
    'jug-pdp-urgency--state2',
    'jug-pdp-urgency--state3',
    'jug-pdp-urgency--state4',
    'jug-pdp-urgency--static'
  ];

  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  /* Build the (expensive) Intl formatters ONCE, not on every tick. */
  var TIME_FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, hour: 'numeric', minute: 'numeric', second: 'numeric',
    hour12: false, weekday: 'short'
  });
  var DATE_FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric'
  });
  var YMD_FMT = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'
  });

  function partVal(parts, type) {
    for (var i = 0; i < parts.length; i++) { if (parts[i].type === type) return parts[i].value; }
    return '';
  }

  function getNow() {
    var parts = TIME_FMT.formatToParts(new Date());
    return {
      weekday: partVal(parts, 'weekday'),
      hour:    parseInt(partVal(parts, 'hour'), 10),
      minute:  parseInt(partVal(parts, 'minute'), 10),
      second:  parseInt(partVal(parts, 'second'), 10)
    };
  }

  function isWeekend(weekday) { return weekday === 'Sat' || weekday === 'Sun'; }
  function pad(n) { return String(n).padStart(2, '0'); }

  function secondsUntil(targetHour, now) {
    return (targetHour - now.hour - 1) * 3600 + (59 - now.minute) * 60 + (60 - now.second);
  }

  function formatCountdown(totalSec) {
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    return h + ':' + pad(m) + ':' + pad(s);
  }

  function setStateClass(el, stateClass) {
    for (var i = 0; i < STATE_CLASSES.length; i++) { el.classList.remove(STATE_CLASSES[i]); }
    el.classList.add(stateClass);
  }

  /* Add N transit days to a Date, skipping Sundays only (UPS moves Saturdays). */
  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) added++;
    }
    return result;
  }

  function formatArrival(date) {
    var parts = DATE_FMT.formatToParts(date);
    return partVal(parts, 'weekday') + ', ' + partVal(parts, 'month') + ' ' + partVal(parts, 'day');
  }

  function denverMidnight(offsetDays) {
    var base = new Date(YMD_FMT.format(new Date()) + 'T00:00:00');
    base.setDate(base.getDate() + (offsetDays || 0));
    return base;
  }

  function render(el, transitDays, showArrival) {
    var now = getNow();
    var weekend = isWeekend(now.weekday);

    function suffix(shipDate) {
      return showArrival ? ' &mdash; arrives by ' + formatArrival(addBusinessDays(shipDate, transitDays)) + '!' : '!';
    }

    var sec, html, stateClass;
    if (!weekend && now.hour < CUTOFF_SAME_DAY) {
      sec = secondsUntil(CUTOFF_SAME_DAY, now);
      html = '<span>⚡ Order in the next <strong style="font-variant-numeric:tabular-nums">' +
        formatCountdown(sec) + '</strong> and it ships today' + suffix(denverMidnight(0)) + '</span>';
      stateClass = 'jug-pdp-urgency--state1';
    } else if (!weekend) {
      sec = secondsUntil(24, now);
      var dow = DAYS.indexOf(now.weekday.length === 3 ? now.weekday : now.weekday.substring(0, 3));
      var tomorrowDow = (dow + 1) % 7;
      var isFridayEvening = (tomorrowDow === 6 || tomorrowDow === 0);
      var shipLabel = isFridayEvening ? 'Monday' : 'tomorrow';
      var daysAhead = isFridayEvening ? (tomorrowDow === 6 ? 3 : 2) : 1;
      html = '<span>Order in the next <strong style="font-variant-numeric:tabular-nums">' +
        formatCountdown(sec) + '</strong> and it ships ' + shipLabel + suffix(denverMidnight(daysAhead)) + '</span>';
      stateClass = 'jug-pdp-urgency--state2';
    } else {
      var daysToMonday = now.weekday === 'Sat' ? 2 : 1;
      sec = secondsUntil(24, now);
      html = '<span>Order in the next <strong style="font-variant-numeric:tabular-nums">' +
        formatCountdown(sec) + '</strong> and it ships Monday' + suffix(denverMidnight(daysToMonday)) + '</span>';
      stateClass = 'jug-pdp-urgency--state4';
    }

    el.innerHTML = ICON_CLOCK + html;
    setStateClass(el, stateClass);
  }

  function init() {
    var el = document.getElementById('jug-pdp-urgency');
    if (!el || el.dataset.countdown !== 'true') return;

    var transitDays = parseInt(el.dataset.transitDays, 10) || 4;
    var showArrival = el.dataset.showArrival !== 'false';

    render(el, transitDays, showArrival);
    /* Tick once per second (not 60×/sec via rAF). Pause when the tab is hidden. */
    var timer = setInterval(function () {
      if (!document.hidden) render(el, transitDays, showArrival);
    }, 1000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render(el, transitDays, showArrival);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* sync */
